export var compKey = 'table-v2';
//# sourceMappingURL=key.js.map